window.addEventListener("load", (event) => {
    console.log("Custom JS Loaded");
    addModalEventListeners();
    document.querySelector(".stickyR_atc").addEventListener("click", (event) => {
      event.target.querySelector(".atc__text").classList.add("hidden");
      event.target.querySelector(".loading__spinner").classList.remove("hidden");
      setTimeout(() => {
        event.target.querySelector(".atc__text").classList.remove("hidden");
        event.target.querySelector(".loading__spinner").classList.add("hidden");
      }, 2000);
    });
    document.addEventListener('ProductAdded', () => {
      closeModal();
    });
    window.addEventListener('stATCcliked', (e) => {
      const htmlStr = e.detail.element;
      const parser = new DOMParser();
      const html = parser.parseFromString(htmlStr, "text/html");
      const buttonObj = html.querySelector('.card-product_atcModal');
      console.log('Custom event received in ProductCard:', buttonObj);
      initModal(buttonObj);
      document.querySelectorAll(".trigger-modal-close").forEach((item) => {
        item.addEventListener("click", () => {
          closeModal();
        })
      })
    });
    document.querySelector(".zoom-announcement").classList.add("appear");
});

// ✅ More reliable: run on every pageshow event
window.addEventListener('pageshow', function () {
  console.log('pageshow fired — refreshing cart');
  setTimeout(() => {
    refreshCartWithDawnAPI();
  }, 500);
});

// ✅ Also refresh on visibility change (tab switch)
document.addEventListener('visibilitychange', function () {
  if (document.visibilityState === 'visible') {
    refreshCartWithDawnAPI();
  }
});

function refreshCartWithDawnAPI() {
  console.log("Inside refresh");
  const cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (!cartElement || typeof cartElement.getSectionsToRender !== 'function') {
    console.warn('Cart element not found or does not support getSectionsToRender');
    return;
  }

  const sections = cartElement.getSectionsToRender().map(section => section.id);
  const url = `/?sections=${sections.join(',')}&sections_url=${window.location.pathname}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Cache-Control': 'no-store'
    }
  })
    .then(res => res.json())
    .then(sectionHTML => {
      // ✅ Wrap response in "sections" key as required by renderContents()
      const wrapped = {
        sections: sectionHTML
      };

      if (typeof CartPerformance !== 'undefined' && CartPerformance?.measure) {
        CartPerformance.measure('refresh:paint-updated-sections', () => {
          cartElement.renderContents(wrapped, false);
        });
      } else {
        cartElement.renderContents(wrapped, false);
      }

      cartElement.classList.remove('is-empty');
    })
    .catch(err => {
      console.error('Failed to refresh cart UI:', err);
    });
}

// Load more in the collection pages start
window.addEventListener("st.collection.paginated",()=>{
  console.log("hi");
  addModalEventListeners();
});
// Load more in the collection pages end
window.addEventListener("PDP:More:Similar:Products:Loaded",()=>{
  addModalEventListeners();
});

const closeToastMsg = () => {
  document.querySelector("#toastMsg").classList.remove("show");
};

const showToastMsg = (msg) => {
  document.querySelector("#toastMsg span").innerHTML = msg;
  document.querySelector("#toastMsg").classList.add("show");
  setTimeout(() => {
    closeToastMsg();
  }, 1000);
};

const mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

const formatMoney = function (e, t) {
  function o(e, t) {
    return void 0 === e ? t : e;
  }
  function r(e, t, r, i) {
    if (
      ((t = o(t, 2)), (r = o(r, ",")), (i = o(i, ".")), isNaN(e) || null == e)
    )
      return 0;
    var a,
      n = (e = (e / 100).toFixed(t)).split(".");
    return (
      n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
      (n[1] ? i + n[1] : "")
    );
  }
  "string" == typeof e && (e = e.replace(".", ""));
  var i = "",
    a = /\{\{\s*(\w+)\s*\}\}/,
    n = t || this.money_format;
  switch (n.match(a)[1]) {
    case "amount":
      i = r(e, 2);
      break;
    case "amount_no_decimals":
      i = r(e, 0);
      break;
    case "amount_with_comma_separator":
      i = r(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = r(e, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      i = r(e, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      i = r(e, 2, "'");
  }
  return n.replace(a, i);
};

const initiateDropdownCheck = () => {
  document
    .querySelector(".cm-cont #custom-modal_quantity-fabrics")
    .addEventListener("change", (e) => {
      console.log(
        "hi working ",
        e.target.options[e.target.selectedIndex].value
      );
      document
        .querySelector(".cm-cont .Rd-input-bar")
        .setAttribute("value", e.target.options[e.target.selectedIndex].value);
      document
        .querySelector(".cm-cont .Rd-input-bar")
        .value = e.target.options[e.target.selectedIndex].value;
    });
};

const closeModal = () => {
  // document.querySelector(".cm-outer-cont").style.display = "none";
  $(".cm-outer-cont").attr("data-modal-open","false");
  $(".cm-outer-cont").fadeOut(100);
  $(".product-form__error-message-wrapper").attr("hidden","");
  $(".product-form__error-message-wrapper .product-form__error-message").text("");
};

const modalQuantityUpdate = (sign) => {
  const inputElement = document.querySelector(".Rd-input-bar");
  const quantMax = parseInt(inputElement.getAttribute("max"));  // Convert to number
  const quantMin = parseInt(inputElement.getAttribute("min"));
  let quantVal = parseInt(inputElement.value);  // Use .value instead of attribute

  if (sign === "+") {
    if (quantVal < quantMax) {
      inputElement.value = quantVal + 1;  // Update .value, not attribute
    }
  } else if (sign === "-") {
    if (quantVal > quantMin) {
      inputElement.value = quantVal - 1;
    }
  }
};

const modalVariantChangeInit = () => {
  document
    .querySelectorAll(".cm-cont .product__varient__container")
    .forEach((item) => {
      item.addEventListener("click", (event) => {
        console.log(item.querySelector("input"));
        const selectedVariantId = item
          .querySelector("input")
          .getAttribute("vatiant");
        const selectedVariantQty = item
          .querySelector("input")
          .getAttribute("qty");
        const selectedVariantPrice = item
          .querySelector("input")
          .getAttribute("price");
        const selectedVariantCompPrice = item
          .querySelector("input")
          .getAttribute("compareprice");

        // update the price
        document.querySelector(".cm-cont .cm-price").innerHTML = formatMoney(
          selectedVariantPrice,
          moneyFormat
        );
        // update the compare at price
        if (
          selectedVariantCompPrice != "null" &&
          selectedVariantCompPrice > selectedVariantPrice
        ) {
          document.querySelector(".cm-cont .cm-compprice").innerHTML =
            formatMoney(selectedVariantCompPrice, moneyFormat);
        } else {
          document.querySelector(".cm-cont .cm-compprice").innerHTML = "";
        }
        // update the compare at disocunt
        if (
          selectedVariantCompPrice != "null" &&
          selectedVariantCompPrice > selectedVariantPrice
        ) {
          document.querySelector(".cm-cont .cm-discount").style.display =
            "block";
          document.querySelector(".cm-cont .cm-discount").innerHTML = parseInt(
            (selectedVariantCompPrice - selectedVariantPrice) /
              selectedVariantCompPrice
          );
        } else {
          document.querySelector(".cm-cont .cm-discount").innerHTML = "";
          document.querySelector(".cm-cont .cm-discount").style.display =
            "none";
        }
        if (document.querySelector('.cm-cont input[name="id"]'))
          // update the atc var id
          document
            .querySelector('.cm-cont input[name="id"]')
            .setAttribute("value", selectedVariantId);

        // update the quantity in quantity selector
        if (document.querySelector(".cm-cont  .custom-modal_quantity-cont")) {
          document
            .querySelector(
              ".cm-cont  .custom-modal_quantity-cont .Rd-input-bar"
            )
            .setAttribute("value", 1);
          document
            .querySelector(
              ".cm-cont  .custom-modal_quantity-cont .Rd-input-bar"
            )
            .setAttribute("max", selectedVariantQty);
        }
      });
    });
};

const modalVariantChangeDel = () => {};

function initModal(element) {
  console.log(element);
  let fetchProdJson;
  
  // show the loading - add 'atc-loading' class
  element.classList.add("atc-loading");
  if (element.classList.contains("tw-sticky-atc")) {
    element.querySelector(".tw-sticky-atcbutton").classList.add("hidden");
    element.querySelector(".tw-atc-loader").classList.remove("hidden");
  }

  document.querySelector(".cm-cont .modal-variants").innerHTML = ``;
  const prodHandle = element.getAttribute("data-handle");
  const prodImg = element.getAttribute("data-image");
  const prodSku = element.getAttribute("data-sku");

  document.querySelector(".cm-img").setAttribute("src", prodImg);

  let productContent;
  console.time("myTimer");
  fetch(window.Shopify.routes.root + `products/${prodHandle}.js`)
    .then((response) => response.json())
    .then((product) => {
      productContent = product;
      fetchProdJson = product;
      console.timeEnd("myTimer");
      // console.log(`productContent = ${JSON.stringify(productContent)}`);

      document.querySelector(".cm-title").innerHTML = productContent.title;
      document.querySelector(
        ".cm-partner"
      ).innerHTML = `Partners: ${productContent.vendor}`;

      // multiplying by 2 since the default should be 1m not 0.5m
      if (productContent.type && productContent.type === "fabrics") {
        document.querySelector(".cm-price").innerHTML = `${formatMoney(
          productContent.price * 2,
          moneyFormat
        )}/meter`;
        if (productContent.compare_at_price > productContent.price) {
          document.querySelector(".cm-compprice").style.display = "block";
          document.querySelector(".cm-compprice").innerHTML = formatMoney(
            productContent.compare_at_price * 2,
            moneyFormat
          );
        }
      } else {
        document.querySelector(".cm-price").innerHTML = formatMoney(
          productContent.price,
          moneyFormat
        );
        if (productContent.compare_at_price > productContent.price) {
          document.querySelector(".cm-compprice").style.display = "block";
          document.querySelector(".cm-compprice").innerHTML = formatMoney(
            productContent.compare_at_price,
            moneyFormat
          );
        }
      }

      if (productContent.compare_at_price > productContent.price) {
        document.querySelector(".cm-discount").style.display = "block";
        document.querySelector(".cm-discount").innerHTML = `${
          (productContent.compare_at_price - productContent.price) /
          productContent.compare_at_price
        }% OFF`;
      } else {
        document.querySelector(".cm-discount").style.display = "none";
      }
            // adding the product url
      document
        .querySelector(".cm-url-new")
        .setAttribute("href", productContent.url);
      // console.log(`(${productContent.featured_image.split("?")[0]} != ${prodImg.split("?")[0]})`);
      // adding the product url
      document
        .querySelector(".cm-viewdetails")
        .setAttribute("href", productContent.url);
      // console.log(`(${productContent.featured_image.split("?")[0]} != ${prodImg.split("?")[0]})`)
      console.log(
        `(${productContent.featured_image
          .split("?")[0]
          .split("/")
          .pop()} != ${prodImg.split("?")[0].split("/").pop()})`
      );
      let fetchImg = productContent.featured_image
        .split("?")[0]
        .split("/")
        .pop();
      let attrImg = prodImg.split("?")[0].split("/").pop();
      if (fetchImg != attrImg) {
        document
          .querySelector(".cm-img")
          .setAttribute(
            "src",
            `${
              productContent.featured_image.split("?")[0]
            }?width=300&height=300&crop=center`
          );
      }

      //update the max in quantity button
      document
        .querySelector(".Rd-input-bar")
        .setAttribute("max", productContent.variants[0].inventory_quantity);

      //reseting quantity at each modal loading
      document
        .querySelector(".Rd-input-bar")
        .setAttribute("value", 1);
      document
        .querySelector(".Rd-input-bar")
        .value = 1;

      // set the prouct id for all the field in atc button
      document
        .querySelector(".cm-cont input[name='product-id']")
        .setAttribute("value", productContent.id);
      document
        .querySelector(".cm-cont button[type='submit'][name='add']")
        .setAttribute(
          "aria-labelledby",
          `${document
            .querySelector(".cm-cont button[type='submit'][name='add']")
            .getAttribute("aria-labelledby")}-${productContent.id}`
        );
      document
        .querySelector(".cm-cont input.product-variant-id")
        .setAttribute("value", productContent.variants[0].id);

      // check the number of variants available
      if (document.querySelector(".cm-cont #custom-modal_quantity-fabrics"))
        document.querySelector(
          ".cm-cont #custom-modal_quantity-fabrics"
        ).innerHTML = "";
      // if only 1 variant is available
      if (productContent.variants.length > 1) {
        if (document.querySelector(".cm-variant-cont")) {
          document.querySelector(".cm-variant-cont").classList.remove("hidden");
          document.querySelector(
            ".cm-variant-label"
          ).innerHTML = `${productContent.options[0].name}:`;
        }

        for (let i = 0; i < productContent.variants.length; i++) {
          console.log("printing Variants");
          document.querySelector(
            ".cm-cont .modal-variants"
          ).innerHTML += `
          <div class="product__varient__container" data-variant-available="${productContent.variants[i].available}" bis_skin_checked="1">
            <script type='variant/json'>
              ${JSON.stringify(productContent.variants[i])}
            </script>
            <input
            type="radio"
            id="${productContent.variants[i].id}--0"
            name="${productContent.id}"
            value="${productContent.variants[i].title}"
            abalabile="${productContent.variants[i].title} ${
            productContent.variants[i].available
          }"
            abalabile_pro="${productContent.variants[i].available}"
            qty="${productContent.variants[i].inventory_quantity}"
            price=${productContent.variants[i].price}
            compareprice=${productContent.variants[i].compare_at_price}
            vatiant="${productContent.variants[i].id}"
            form=""
            varients=""
            ${i === 0 ? 'checked=""' : ""}
            />

            <label for="${
              productContent.variants[i].id
            }--0" class="value__label">
            ${productContent.variants[i].title}
              <span class="visually-hidden">
                Variant sold out or unavailable
              </span>
            </label>
          </div>
            `;
        }

        document.querySelector(".modal-variants").style.display = "flex";
      } else {
        document.querySelector(".modal-variants").style.display = "none";
        if (document.querySelector(".cm-variant-cont"))
          document.querySelector(".cm-variant-cont").classList.add("hidden");
      }
      // console.log('quantity: ',productContent.variants[0].inventory_quantity,productContent)
      console.log("productContent.type ", productContent.type);
      if (
        productContent.variants.length === 1 ||
        (productContent.type && productContent.type === "fabrics")
      ) {
        document
          .querySelector(".cm-cont form[data-type=add-to-cart-form]")
          .classList.add("modified-quantity");

        document
          .querySelector(".cm-cont .Rd-input-bar")
          .classList.add("hidden");
        document
          .querySelector(".cm-cont .modal-icon.modal-minus")
          .classList.add("hidden");
        document
          .querySelector(".cm-cont .modal-icon.modal-plus")
          .classList.add("hidden");
        document
          .querySelector(".custom-modal_quantity-cont")
          .classList.add("full-width");
        document
          .querySelector(".cm-cont #custom-modal_quantity-fabrics")
          .classList.remove("hidden");

        let quantEnd;
        if (productContent.variants[0].inventory_quantity > 20) quantEnd = 20;
        else quantEnd = productContent.variants[0].inventory_quantity;
        for (let j = 1; j <= quantEnd; j++) {
          if (
            document.querySelector(".cm-cont #custom-modal_quantity-fabrics")
          ) {
            if (
              productContent.variants.length === 1 &&
              productContent.type &&
              productContent.type === "fabrics"
            ) {
              document.querySelector(".cm-cont .qty-label-size.onlymobile").textContent = "Select Length: ";
              document.querySelector(
                ".cm-cont #custom-modal_quantity-fabrics"
              ).innerHTML += `<option value="${j}">${parseFloat(
                j / 2
              )} meter</option>`;
            } else if (productContent.variants.length === 1) {
              document.querySelector(".cm-cont .qty-label-size.onlymobile").textContent = "Quantity: ";
              document.querySelector(
                ".cm-cont #custom-modal_quantity-fabrics"
              ).innerHTML += `<option value="${j}">Quantity - ${parseFloat(
                j / 1
              )}</option>`;
            }
          }
        }

        initiateDropdownCheck();
      } else {
        document
          .querySelector(".cm-cont form[data-type=add-to-cart-form]")
          .classList.remove("modified-quantity");

        document
          .querySelector(".cm-cont .Rd-input-bar")
          .classList.remove("hidden");
        document
          .querySelector(".cm-cont .modal-icon.modal-minus")
          .classList.remove("hidden");
        document
          .querySelector(".cm-cont .modal-icon.modal-plus")
          .classList.remove("hidden");

        document
          .querySelector(".cm-cont #custom-modal_quantity-fabrics")
          .classList.add("hidden");
      }
      // console.log("productContent ",productContent)
      // console.log("varaints: ", productContent.variants);

      modalVariantChangeInit();

      // remove the loading - remove 'atc-loading' class
      element.classList.remove("atc-loading");
      if (element.classList.contains("tw-sticky-atc")) {
        element
          .querySelector(".tw-sticky-atcbutton")
          .classList.remove("hidden");
        element.querySelector(".tw-atc-loader").classList.add("hidden");
      }
    })
    .then((e) => {
      $(".cm-outer-cont").attr("data-modal-open","true");
      $(".cm-outer-cont").fadeIn(100);
    })
    .catch((error) => {
      // Handle the error here
      console.error("There was a problem with the fetch operation:", error);
      // hide the loading - remove 'atc-loading' class
      element.classList.remove("atc-loading");
      if (element.classList.contains("tw-sticky-atc")) {
        element
          .querySelector(".tw-sticky-atcbutton")
          .classList.remove("hidden");
        element.querySelector(".tw-atc-loader").classList.add("hidden");
      }
    });
}

function checkAndAssignTopStyle(){
  if(document.querySelector('.st-filter-bar.hidden-desktop') || document.querySelector('.initialCollectionToolbar')){
        let header = document.querySelectorAll('.header-wrapper');
        let headerHeight = 0
        if(header && header.length > 0){
          headerHeight = header[0].offsetHeight;
        }
        console.log("head", header, headerHeight);
        if(headerHeight > 0){
          let toolbarSearch = document.querySelector('.st-filter-bar.hidden-desktop');
          let toolbarCollection = document.querySelector('.initialCollectionToolbar')
          if(toolbarSearch) {toolbarSearch.style.top = headerHeight + 'px';}
          if(toolbarCollection) {toolbarCollection.style.top = (headerHeight-1) + 'px';}
        }
      }
}

// Function to safely attach event listeners without duplication
function addModalEventListeners() {
  console.log("Attaching modal event listeners...");

  // Attach listener for "Open Modal" buttons
  document.querySelectorAll('.trigger-modal-open').forEach((button) => {
    if (!button.dataset.listenerAdded) { // Check if the listener is already added
      button.addEventListener('click', (event) => {
        const targetButton = event.currentTarget;
        if (typeof initModal === 'function') {
          initModal(targetButton);
        } else {
          console.error('initModal is not defined');
        }
      });
      button.dataset.listenerAdded = "true"; // Mark this button as having a listener
    }
  });

  // Attach listener for "Close Modal" buttons
  document.querySelectorAll('.trigger-modal-close').forEach((button) => {
    if (!button.dataset.listenerAdded) {
      button.addEventListener('click', () => {
        if (typeof closeModal === 'function') {
          closeModal();
        } else {
          console.error('closeModal is not defined');
        }
      });
      button.dataset.listenerAdded = "true";
    }
  });

  // Attach listener for "Update Quantity" buttons
  document.querySelectorAll('.trigger-modal-quantity').forEach((button) => {
    if (!button.dataset.listenerAdded) {
      button.addEventListener('click', (event) => {
        const action = event.currentTarget.getAttribute('data-action');
        if (typeof modalQuantityUpdate === 'function') {
          modalQuantityUpdate(action);
        } else {
          console.error('modalQuantityUpdate is not defined');
        }
      });
      button.dataset.listenerAdded = "true";
    }
  });
}
